<template>
  <button @click="$emit('click')" class="h-empty-btn add-btn h-btn">
    <svg width="8" height="9" viewBox="0 0 8 9" fill="#fff" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 5.11667H4.88333V8.25H3.13333V5.11667H0V3.36667H3.13333V0.25H4.88333V3.36667H8V5.11667Z"/>
    </svg>
  </button>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

.add-btn {
  width: 20px;
  height: 20px;
  border-radius: 100%;
  transition: background 0.3s ease;

  &:hover {
    background: rgba(#fff, 0.2);
  }
}

</style>